import { Wrapper } from "../styles/Output.styled";

const Email = () => {
  return (
    <Wrapper>
      <span>To contact me, please use the Contact form on the desktop.</span>
      <br />
      <span>Click the Contact icon or open it from the Start menu.</span>
    </Wrapper>
  );
};

export default Email;
